import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "py-2 bg-light shadow-lg container-fluid" }
const _hoisted_2 = { class: "navbar-light text-center d-flex justify-content-center shadow-sm" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.links, (link) => {
        return (_openBlock(), _createElementBlock("div", {
          key: link.href,
          class: ""
        }, [
          _createElementVNode("a", {
            class: "btn btn-primary fw-bolder mx-1 font-monospace",
            "aria-current": "page",
            href: link.href
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["bi", link.logo])
            }, null, 2)
          ], 8, _hoisted_3)
        ]))
      }), 128))
    ])
  ]))
}